import React from "react";
import { injectIntl } from "react-intl";
import { Type } from "discover.medical.react-component-library";

const Error = (props) => {
  const { intl } = props;
  const title = intl.formatMessage(props.title);
  const message = intl.formatMessage(props.message);
  return (
    <>
      <Type element="h1" styledAs="h2" fontFamily="secondary" marginBottom="sm">
        <span dangerouslySetInnerHTML={{ __html: title }}></span>
      </Type>
      <Type element="p">
        <span dangerouslySetInnerHTML={{ __html: message }}></span>
      </Type>
    </>
  );
};

export default injectIntl(Error);
